/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = None

1 = Cost Category

2 = Assembly

3 = Proposal Worksheet

4 = Takeoff Assemblies


 */
export type ProposalGroupTypes =
  (typeof ProposalGroupTypes)[keyof typeof ProposalGroupTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProposalGroupTypes = {
  None: 0,
  CostCategory: 1,
  Assembly: 2,
  ProposalWorksheet: 3,
  Takeoff: 4,
} as const;
